module.exports = __webpack_public_path__ + "static/media/alimentacao.80fdb55e.svg";